import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { InitialsModule } from 'src/app/pipes/initials/initials.module';
import { AvatarComponent } from './avatar.component';

@NgModule({
   declarations: [AvatarComponent],
   exports: [AvatarComponent],
   imports: [CommonModule, FileUrlPipeModule, InitialsModule],
})
export class AvatarModule {}
